<template>
    <svg
        id="icon_tip"
        xmlns="http://www.w3.org/2000/svg"
        width="24.212"
        height="23.999"
        viewBox="0 0 24.212 23.999"
    >
        <path
            id="Subtraction_4"
            data-name="Subtraction 4"
            d="M2796-483a11.924,11.924,0,0,1-8.486-3.514A11.921,11.921,0,0,1,2784-495a11.921,11.921,0,0,1,3.515-8.485A11.924,11.924,0,0,1,2796-507a11.92,11.92,0,0,1,4.717.963,4.53,4.53,0,0,0-1.3,1.639A9.939,9.939,0,0,0,2796-505a10.012,10.012,0,0,0-10,10,10.012,10.012,0,0,0,10,10,10.011,10.011,0,0,0,10-10,9.938,9.938,0,0,0-.6-3.419,4.536,4.536,0,0,0,1.639-1.3A11.922,11.922,0,0,1,2808-495a11.921,11.921,0,0,1-3.515,8.485A11.92,11.92,0,0,1,2796-483Z"
            transform="translate(-2784 507)"
            fill="#854b97"
        />
        <path
            id="Path_472"
            data-name="Path 472"
            d="M4.577,3.9a5.458,5.458,0,0,1,2.79.7l.448-1.322a5.131,5.131,0,0,0-2.706-.775V.8H3.889V2.539C1.814,2.783.847,4,.847,5.311c0,1.407,1,2.356,3.407,3.016,1.557.4,2.3.833,2.3,1.68s-.94,1.378-2.356,1.378a5.72,5.72,0,0,1-3.126-.8L.622,11.9a5.707,5.707,0,0,0,3.2.89v1.652h1.22V12.737c2.131-.259,3.169-1.551,3.169-2.844,0-1.609-.884-2.4-3.212-3.045C3.189,6.316,2.5,5.857,2.5,5.2,2.5,4.607,2.922,3.9,4.577,3.9Z"
            transform="translate(7.585 4.465)"
            fill="#854b97"
            fill-rule="evenodd"
        />
        <path
            id="Rectangle_51"
            data-name="Rectangle 51"
            d="M2,0H2A2,2,0,0,1,4,2V6A0,0,0,0,1,4,6H0A0,0,0,0,1,0,6V2A2,2,0,0,1,2,0Z"
            transform="translate(15.726 3.828) rotate(-45)"
            fill="#854b97"
        />
        <path
            id="Rectangle_52"
            data-name="Rectangle 52"
            d="M0,0H4A0,0,0,0,1,4,0V4A2,2,0,0,1,2,6H2A2,2,0,0,1,0,4V0A0,0,0,0,1,0,0Z"
            transform="translate(19.969 8.071) rotate(-135)"
            fill="#854b97"
        />
    </svg>
</template>
